import { useState } from "react";
import {
  FormFeedback,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { BsEye, BsEyeSlash } from "react-icons/bs";

export const InputField = (props) => {
  const {
    error,
    label,
    focus,
    preAddon = false,
    postAddon = false,
    labelClass,
    boxClass,
    labelSpan,
    labelSpanClass,
    preAddonClass,
    maxLength,
    type,
    rows,
    disabled,
    innerRef,
    style,
    onKeyDown,
    data,
    showPassword,
    showHandle,
    floating,
    value,
    onFocus,
    onBlur,
  } = props;
  const invalid = !!(focus && error);
  const valid = !!(focus && !error);
  const [isFocused, setIsFocused] = useState(false);

  // Opt-in floating label: label sits inside the field at rest and floats
  // above it once focused or filled - doesn't touch the default (label
  // above input) rendering used everywhere else in the app. File/checkbox
  // inputs have no natural "filled" text state to float a label around, so
  // they always fall back to the static label even if a caller passes
  // `floating` (keeps every call site simple - no per-field-type branching
  // needed by callers).
  const useFloating = floating && type !== "file" && type !== "checkbox";
  const hasValue = value !== undefined && value !== null && String(value).length > 0;
  const isFloatingActive = isFocused || hasValue;

  const input = (
    <Input
      invalid={invalid}
      valid={valid}
      {...props}
      autoComplete="off"
      style={style}
      type={data === "password" && showPassword ? "text" : type}
      rows={rows}
      disabled={disabled}
      innerRef={innerRef}
      onKeyDown={onKeyDown}
      placeholder={useFloating ? " " : props.placeholder}
      onFocus={(e) => {
        setIsFocused(true);
        onFocus?.(e);
      }}
      onBlur={(e) => {
        setIsFocused(false);
        onBlur?.(e);
      }}
    />
  );

  if (useFloating) {
    return (
      <FormGroup
        className={`${boxClass || ""} floating-field ${isFloatingActive ? "is-active" : ""} ${invalid ? "has-error" : ""}`}
      >
        <InputGroup className="anvTxt_fielW">
          {preAddon && <InputGroupText>{preAddon}</InputGroupText>}
          {input}
          {label && (
            <Label className={`floating-label ${labelClass || ""}`}>
              {label}
              <span className={labelSpanClass}>{labelSpan}</span>
            </Label>
          )}
          {data !== "password" && (
            <button className="fltBtn">{data?.data?.unit_details?.name}</button>
          )}
          {data === "password" &&
            (showPassword ? (
              <BsEye className="fltBtn2" onClick={showHandle} />
            ) : (
              <BsEyeSlash className="fltBtn2" onClick={showHandle} />
            ))}
          {postAddon && <InputGroupText>{postAddon}</InputGroupText>}
        </InputGroup>
        {invalid && <FormFeedback>{error}</FormFeedback>}
      </FormGroup>
    );
  }

  return (
    <FormGroup className={boxClass}>
      {label && (
        <Label className={labelClass}>
          {label}
          <span className={labelSpanClass}>{labelSpan}</span>
        </Label>
      )}
      <InputGroup className="anvTxt_fielW">
        {preAddon && <InputGroupText>{preAddon}</InputGroupText>}
        {input}
        {data !== "password" && (
          <button className="fltBtn">{data?.data?.unit_details?.name}</button>
        )}
        {data === "password" &&
          (showPassword ? (
            <BsEye className="fltBtn2" onClick={showHandle} />
          ) : (
            <BsEyeSlash className="fltBtn2" onClick={showHandle} />
          ))}
        {postAddon && <InputGroupText>{postAddon}</InputGroupText>}
      </InputGroup>
      {invalid && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>
  );
};
